module.exports = __webpack_public_path__ + "media/assets/images/caret-right-28163382d091e3b5bcdc124e90befe20.svg";